import cashPaymentIcon from "../../assets/generated/quick-facts/cash-payment.svg";
import deregistrationFeeIcon from "../../assets/generated/quick-facts/deregistration-fee.svg";
import towingFeeIcon from "../../assets/generated/quick-facts/towing-fee.svg";
import { quickFacts } from "../../content/site";

const quickFactIcons = {
  towing: {
    src: towingFeeIcon,
    asset: "quick-facts-towing-fee",
  },
  deregistration: {
    src: deregistrationFeeIcon,
    asset: "quick-facts-deregistration-fee",
  },
  cash: {
    src: cashPaymentIcon,
    asset: "quick-facts-cash-payment",
  },
} as const;

export function QuickFacts() {
  return (
    <section
      className="quick-facts"
      data-review-region="quick-facts"
      aria-labelledby="quick-facts-title"
    >
      <div className="section-shell">
        <h2 className="sr-only" id="quick-facts-title">費用とお支払いの条件</h2>
        <dl className="quick-facts__list">
          {quickFacts.map((fact) => {
            const icon = quickFactIcons[fact.icon];

            return (
              <div
                className={`quick-facts__item quick-facts__item--${fact.priority}`}
                key={fact.id}
              >
                <dt className="quick-facts__term">
                  <img
                    className="quick-facts__icon"
                    src={icon.src}
                    alt=""
                    aria-hidden="true"
                    data-generated-asset={icon.asset}
                  />
                  <span className="quick-facts__label">{fact.label}</span>
                </dt>
                <dd>
                  {"value" in fact ? (
                    <strong className="quick-facts__value">{fact.value}</strong>
                  ) : (
                    <span className="quick-facts__description">
                      {fact.description}
                    </span>
                  )}
                </dd>
              </div>
            );
          })}
        </dl>
      </div>
    </section>
  );
}
